import React, {useState} from "react";
import {StepList} from "./StepList";
import {StepContent} from "./StepContent";

function StepValues({values}) {
    return <ul className="clc-values">
        {Object.keys(values).filter(n => !!values[n]).map(name => <li key={name}>
            <div className="media">
                <figure className="media-left">
                    <p className="image is-128x128">
                        <img src={values[name].img} alt={values[name].name}/>
                    </p>
                </figure>
                <div className="media-content">
                    <p className="title is-6">{values[name].name}</p>
                    <p className="subtitle is-6">{values[name].desc}</p>
                </div>
            </div>
        </li>)}
    </ul>;
}

export function StepCalculator({steps, getTotal, children, activeStep, setActiveStep}) {
    let [selectedValues, setSelectedValues] = useState({});
    const selectStep = name => steps.filter(item => item.name === name).pop();
    const setActiveValue = (value, index) => {
        setSelectedValues(Object.assign({}, selectedValues, {
            [activeStep.name]: Object.assign({}, value, { index })
        }));
        if (value !== null) setActiveStep(selectStep(activeStep.next));
    };
    const isCurrentValueSelected = () => !!selectedValues[activeStep.name];

    return (<div className="dg-calc">
        <StepList items={steps} activeItem={activeStep.name}/>

        {(activeStep.name !== 'price') ? <StepContent
            size={activeStep.column}
            values={activeStep.values}
            onSelect={(value, index) => setActiveValue(value, index)}
            selectedItem={selectedValues[activeStep.name]}
        /> : null}

        {children({
            total: getTotal(selectedValues),
            values: <StepValues values={selectedValues}/>,
            orderItems: selectedValues ? Object.values(selectedValues)
                .filter(item => !!item)
                .map(item => item.name) : []
        })}

        {activeStep ? <div className="dg-calc-nav">
            <button
                className="button"
                disabled={!activeStep.prev}
                onClick={() => setActiveStep(selectStep(activeStep.prev))}
            >назад
            </button>
            <button
                className="button"
                disabled={!activeStep.next || !isCurrentValueSelected()}
                onClick={() => setActiveStep(selectStep(activeStep.next))}
            >вперед
            </button>
        </div> : null}
    </div>);
}